import img from "../assets/img.png";
import img2 from "../assets/img-2.png";
function AboutBlock() {
    return ( 
        <>
            <section className="about-block" id="who-we-are">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-6">
                            <div className="about-img-wrapper">
                                <img src={img} alt="" />
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6">
                            <h2>
                                It's not enough to save the day! We also have to change the world!
                            </h2>
                            <p class="main-paragraph">
                                For over 5 years, we’ve been working to create a better world for animals. Together with you, we continue our lifesaving work to tackle the root causes of suffering for animals everywhere.
                            </p>
                            <p>
                                We create meaningful change for animals by tackling the toughest challenges, no matter where they are. By focusing on the most urgent needs, we strive to make the greatest impact.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-block about-block-updated">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-6">
                            <h2>
                                Thanks to you, more animals are finding safe and loving homes than ever before!
                            </h2>
                            <p className="main-paragraph">
                                Across the country, shelters are making incredible progress in helping pets in need.
                            </p>
                            <p>
                                By working together, we can provide even more animals with the care and support they deserve—creating happier, healthier communities for both people and pets.
                            </p>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6">
                            <div className="about-img-wrapper">
                                <img src={img2} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default AboutBlock;